// 按设备选页面变体的辅助
//
// router 里用：component: devicePage(() => import('./mobile/Home.vue'),
//                                     () => import('./desktop/Home.vue'))
//
// 返回一个轻量包装组件：根据 useDevice 的 isDesktop 响应式渲染对应变体。
// - 没传 desktop loader 的路由，PC 下回退到 mobile 变体（渐进式上线，不用一次写完）。
// - isDesktop 变化（resize / 手动切换）会实时切换变体，无需刷新。

import { defineComponent, defineAsyncComponent, h, type Component } from "vue";
import { isDesktop } from "@/composables/useDevice";

type Loader = () => Promise<{ default: Component }>;

export function devicePage(
  mobileLoader: Loader,
  desktopLoader?: Loader,
  // 包装组件名：传路由名（如 "Home"）让 <keep-alive :include> 能命中缓存
  name = "DevicePage",
) {
  const Mobile = defineAsyncComponent(mobileLoader);
  const Desktop = desktopLoader ? defineAsyncComponent(desktopLoader) : Mobile;
  return defineComponent({
    name,
    setup() {
      return () => h(isDesktop.value ? Desktop : Mobile);
    },
  });
}
